import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $withOverflow: boolean; $maxHeight: number }>`
  overflow: auto;

  ${props =>
    props.$withOverflow &&
    css`
      padding-right: 8px;
      max-height: ${props.$maxHeight}px;
    `}
`;
